import { array } from "@amcharts/amcharts5";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { infoDetailsProps } from "types/models/infoDetailsProps";

type State = {
  data: infoDetailsProps;
  setLoadingInfo: boolean;
  id: number | string;
  idReceipt: number | string;
  isNearPdp: boolean;
  isDilatePatient: boolean;
  isPmt: boolean;
  inDetail: boolean;
  selectedRowKeys: any;
  dataOrthoK: any;
};

const initialState: State = {
  data: null,
  setLoadingInfo: false,
  id: null,
  isNearPdp: false,
  isDilatePatient: false,
  isPmt: false,
  idReceipt: null,
  inDetail: null,
  selectedRowKeys: [],
  dataOrthoK: [],
};

export const pendingSlice = createSlice({
  name: "pending",
  initialState: initialState,
  reducers: {
    setData: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        data: actions.payload,
      };
    },
    setLoadingInfo: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        setLoadingInfo: actions.payload,
      };
    },
    setIdRefraction: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        id: actions.payload,
      };
    },
    setIdReceipt: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idReceipt: actions.payload,
      };
    },
    setIsPmt: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        isPmt: actions.payload,
      };
    },
    setIsNearPdp: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        isNearPdp: actions.payload,
      };
    },
    setIsDilatePatient: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        isDilatePatient: actions.payload,
      };
    },
    setInDetail: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        inDetail: actions.payload,
      };
    },
    setSelectedRowKeys: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        selectedRowKeys: actions.payload,
      };
    },
    setDataOrthoK: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        dataOrthoK: actions.payload,
      };
    },
  },
});

export const {
  setIsPmt,
  setIsNearPdp,
  setIsDilatePatient,
  setData,
  setLoadingInfo,
  setIdRefraction,
  setIdReceipt,
  setInDetail,
  setSelectedRowKeys,
  setDataOrthoK,
} = pendingSlice.actions;
export default pendingSlice.reducer;
